function ValidationError(message){
    this.message = message;
}

export default ValidationError;